import {
  get,
  post,
} from '@/utils/request';

const url = 'student-update-records';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function getStudentUpdateRecordsByStudentId({ page, size, student_id }) {
  return get({
    url: `${url}/students/${student_id}`,
    data: { page, size },
  });
}
